import { invokeApi } from "../bl_libs/invokeApi";

export const get_conversations_api = async (search) => {
  const requestObj = {
    path: `api/conversations/list?search=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
